import styled, { css } from 'styled-components';
import { BannerHeading, SectionHeading, Subtitle } from '../../global/typography';

export const StyledSection = styled.section`
    position: relative;
    display: flex;
    align-items: center;
    gap: 50px;
    padding: 3.12rem 0;
    flex-direction: column;
`;

export const StyledContainer = styled.div<{ $flex: 'row' | 'column' }>`
    display: flex;
    width: 100%;
    justify-content: center;

    ${props =>
        props.$flex === 'row' &&
        css`
            flex-direction: row;

            @media (max-width: 979px) {
                flex-direction: column;
            }
        `}

    ${props =>
        props.$flex === 'column' &&
        css`
            flex-direction: column;
        `}
`;

export const ButtonsContainer = styled.div`
    display: flex;
    gap: 30px;
    flex-wrap: wrap;
`;

export const MainHeroHeading = styled(BannerHeading)`
    color: white;
`;

export const StyledTitle = styled(SectionHeading)`
    margin-bottom: 10px;
`;

export const StyledCounterSection = styled.div<{ $layout: '2x3' | '1x4' }>`
    display: grid;
    gap: 20px;

    ${props =>
        props.$layout === '2x3' &&
        css`
            grid-template-columns: repeat(3, minmax(0px, 1fr));
        `}

    ${props =>
        props.$layout === '1x4' &&
        css`
            grid-template-columns: repeat(4, minmax(0px, 1fr));
        `}


    @media (max-width: 979px) {
        grid-template-columns: repeat(2, minmax(0px, 1fr));
    }

    @media (max-width: 600px) {
        grid-template-columns: repeat(1, minmax(0px, 1fr));
    }
`;

export const StyledSubtitle = styled(Subtitle)``;
